import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function ThumbDownAltOutlined(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M15 3H9v12h6V3zm4 0h-2v12h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM2 13v6c0 1.1.9 2 2 2h8v-8H4c-.55 0-1-.45-1-1z" />
    </SvgIcon>
  )
}
